import React, { useState } from 'react';
import { Checkbox, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import PageHeader from 'components/pageHeader';
import { InputSearch } from 'components/customInputs';
import { Button } from 'components/Button';
import { fluid } from 'components/UserDashboardV2/utils/responsive';

import CreateAccessDrawer from './createAccessDrawer';
import "../userTableV2.css"
import UserActionConfirmModal from './userActionConfirmModal';

const ACCESS_DATA = [
    {
        id: 1,
        name: 'Staff manager',
        view: 'Attendance, Announcement, Marketplace',
        edit: 'Staff management',
    },
    {
        id: 2,
        name: 'Student manager',
        view: 'Courses, Attendance, Schedule, Test',
        edit: 'Student management, Fee management',
    },
    {
        id: 3,
        name: 'Fee manager',
        view: 'Student management, Courses',
        edit: 'Fee management',
    },
    {
        id: 4,
        name: 'Operations admin',
        view: 'Staff management, Student management',
        edit: 'Announcement, Schedule, Batches, Attendance',
    },
    {
        id: 5,
        name: 'Academic admin',
        view: 'Student management, Attendance',
        edit: 'Courses, Schedule, Library, Test',
    },
    {
        id: 6,
        name: 'Staff manager',
        view: 'Attendance, Announcement, Marketplace',
        edit: 'Staff management',
    },
    {
        id: 7,
        name: 'Student manager',
        view: 'Courses, Attendance, Schedule, Test',
        edit: 'Student management, Fee management',
    },
    {
        id: 8,
        name: 'Fee manager',
        view: 'Student management, Courses',
        edit: 'Fee management',
    },
    {
        id: 9,
        name: 'Operations admin',
        view: 'Staff management, Student management',
        edit: 'Announcement, Schedule, Batches, Attendance',
    },
    {
        id: 10,
        name: 'Academic admin',
        view: 'Student management, Attendance',
        edit: 'Courses, Schedule, Library, Test',
    }, {
        id: 11,
        name: 'Staff manager',
        view: 'Attendance, Announcement, Marketplace',
        edit: 'Staff management',
    },
    {
        id: 12,
        name: 'Student manager',
        view: 'Courses, Attendance, Schedule, Test',
        edit: 'Student management, Fee management',
    },
    {
        id: 13,
        name: 'Fee manager',
        view: 'Student management, Courses',
        edit: 'Fee management',
    },
    {
        id: 14,
        name: 'Operations admin',
        view: 'Staff management, Student management',
        edit: 'Announcement, Schedule, Batches, Attendance',
    },
    {
        id: 15,
        name: 'Academic admin',
        view: 'Student management, Attendance',
        edit: 'Courses, Schedule, Library, Test',
    },
];


const AccessManagement = ({ onBack }) => {
    const [search, setSearch] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [confirmIsBulk, setConfirmIsBulk] = useState(false);
    const [createAccessDrawerOpen, setCreateAccessDrawerOpen] = useState(false);
    const [accessDrawerMode, setAccessDrawerMode] = useState('create');
    const [selectedAccess, setSelectedAccess] = useState(null);

    const filteredData = ACCESS_DATA.filter((item) =>
        item.name
            .toLowerCase()
            .includes(search.toLowerCase())
    );


    const toggleRow = (id, checked) => {
        setSelectedRows((prev) =>
            checked
                ? [...prev, id]
                : prev.filter((item) => item !== id)
        );
    };


    const toggleAll = (checked) => {
        setSelectedRows(
            checked
                ? filteredData.map((item) => item.id)
                : []
        );
    };
    const openConfirmModal = (action, isBulk = false) => {
        setConfirmAction(action);
        setConfirmIsBulk(isBulk);
        setConfirmModalOpen(true);
    };

    const closeConfirmModal = () => {
        setConfirmModalOpen(false);
        setConfirmAction(null);
        setConfirmIsBulk(false);
    };
    const handleEditAccess = (item) => {

        // FIRST close dropdown
        setOpenDropdownId(null);

        // Set selected access
        setSelectedAccess(item);

        // Tell drawer it is edit mode
        setAccessDrawerMode('edit');

        // Open drawer
        setCreateAccessDrawerOpen(true);
    };
    const handleCreateAccess = () => {
        setSelectedAccess(null);
        setAccessDrawerMode('create');
        setCreateAccessDrawerOpen(true);
    };

    const actions = selectedRows.length > 0
        ? [
            <div
                key="bulk-actions"
                className="bulk-actions "
            >
                <button
                    type="button"
                    className="bulk-delete-btn"
                    onClick={() => openConfirmModal(
                        'accessDelete',
                        selectedRows.length > 1
                    )}
                >
                    DELETE
                </button>
            </div>
        ]
        : [
            <div
                key="access-header-actions"
                className="access-header-actions"
            >
                <InputSearch
                    value={search}
                    allowClear
                    placeholder="Search by access name"
                    onChange={(value) =>
                        setSearch(
                            typeof value === 'string'
                                ? value
                                : value?.target?.value || ''
                        )
                    }
                    style={{
                        width: fluid(280),
                        height: fluid(40),
                        borderRadius: fluid(24),
                    }}
                />

                <button
                    type="button"
                    className="create-access-btn"
                    onClick={handleCreateAccess}
                >
                    CREATE ACCESS
                </button>
            </div>
        ];

    return (
        <>
            <div className="access-management-page" style={{ margin: -20, padding: "40px 8px 20px 8px", width: "calc(100% + 30px)", height: "100vh", boxSizing: "border-box", display: "flex", flexDirection: "column", overflow: "hidden" }}>

                <PageHeader
                    title="Manage access"
                    onBackPress={onBack}
                    actions={actions}
                />

                <div className="access-table-container" style={{ margin: "30px 0px 0px 0px", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>

                    <div className="access-table-header">

                        <div className="staff-header-cell access-header-checkbox">
                            <Checkbox
                                checked={
                                    filteredData.length > 0 &&
                                    selectedRows.length ===
                                    filteredData.length
                                }
                                indeterminate={
                                    selectedRows.length > 0 &&
                                    selectedRows.length <
                                    filteredData.length
                                }
                                onChange={(e) =>
                                    toggleAll(
                                        e.target.checked
                                    )
                                }
                            />
                        </div>

                        <div className="staff-header-cell">ACCESS NAME</div>
                        <div className="staff-header-cell">VIEW ACCESS</div>
                        <div className="staff-header-cell">EDIT ACCESS</div>
                        <div className="staff-header-cell">ACTIONS</div>

                    </div>

                    <div className="access-table-body">

                        {filteredData.map((item) => (
                            <div
                                className={`access-table-row ${selectedRows.includes(item.id) ? 'selected-row' : ''}`}
                                key={item.id}
                            >

                                <div className="access-cell access-row-checkbox">
                                    <Checkbox
                                        checked={selectedRows.includes(item.id)}
                                        onChange={(e) => toggleRow(item.id, e.target.checked)}
                                    />
                                </div>

                                <div className="access-cell access-value">
                                    {item.name}
                                </div>

                                <div className="access-cell access-value">
                                    {item.view}
                                </div>

                                <div className="access-cell access-value">
                                    {item.edit}
                                </div>

                                <div className="access-cell access-actions">
                                    <Dropdown
                                        trigger={['click']}
                                        placement="bottomRight"
                                        open={openDropdownId === item.id}
                                        onOpenChange={(open) =>
                                            setOpenDropdownId(
                                                open ? item.id : null
                                            )
                                        }
                                        overlayClassName="staff-actions-dropdown"
                                        menu={{
                                            items: [
                                                {
                                                    key: 'edit',
                                                    label: 'Edit',
                                                    onClick: () => handleEditAccess(item),
                                                },
                                                {
                                                    key: 'delete',
                                                    label: 'Delete',
                                                    danger: true,
                                                    onClick: () => {
                                                        setOpenDropdownId(null);
                                                        openConfirmModal('accessDelete', false);
                                                    },
                                                },
                                            ],
                                        }}
                                    >
                                        <button
                                            type="transparent"
                                            className={`access-more-button ${openDropdownId === item.id
                                                ? 'open'
                                                : ''
                                                }`}
                                            style={{ width: fluid(32), height: fluid(32), padding: 0, }}
                                        >
                                            <MoreOutlined className="access-more-icon" />
                                        </button>
                                    </Dropdown>
                                </div>

                            </div>
                        ))}

                    </div>
                </div>

            </div>

            <CreateAccessDrawer
                open={createAccessDrawerOpen}
                onClose={() => {
                    setCreateAccessDrawerOpen(false);
                    setSelectedAccess(null);
                }}
                mode={accessDrawerMode}
                editAccess={selectedAccess}
                onCreate={(payload) => {
                    console.log('CREATE ACCESS:', payload);

                    // API create call here
                }}

                onUpdate={(payload) => {
                    console.log('UPDATE ACCESS:', payload);

                    // API update call here
                }}
            />
            <UserActionConfirmModal
                open={confirmModalOpen}
                onCancel={closeConfirmModal}
                onConfirm={async () => {
                    console.log(
                        'Delete access:',
                        selectedRows
                    );

                    setSelectedRows([]);
                    closeConfirmModal();
                }}
                action={confirmAction}
                isBulk={confirmIsBulk}
            />
        </>
    );
};


export default AccessManagement;